/* eslint-disable max-len */
import { useMemo } from 'react';
import { BookableServiceV2 } from '@acp/shared';
import { useBookableServices } from '../../booking/hooks/use-booking';

export function useBookableServiceOptions(
    propertyId: number,
    overrideBookableServices: BookableServiceV2[] | null,
    returnServiceIds: boolean = false
) {
    const bookableServicesQuery = useBookableServices({
        propertyId,
        overrideBookableServices,
    });

    const serviceOptions = useMemo(() => {
        if (bookableServicesQuery.isLoading) {
            return [];
        }

        const services = bookableServicesQuery?.data ?? [];
        return services.map((service) => ({
            label: service.name,
            value: returnServiceIds ? service?.services?.join(',') : service?.bookingTypes?.join(','),
        }));
    }, [bookableServicesQuery.data, bookableServicesQuery.isLoading, returnServiceIds]);

    return {
        isLoading: bookableServicesQuery.isLoading,
        serviceOptions,
    };
}
